import { Component, inject, Input } from '@angular/core';
import { AccountDTO } from '@data/auth/AccountDTO';
import { MenuItem } from '@data/common/MenuItem';
import { Select, Store } from '@ngxs/store';
import { ApplicationSelectors } from '@shared/store/application/application.selectors';
import { AuthSelectors } from '@shared/store/auth/auth.selectors';
import { NotificationsSelectors } from 'app/view/notifications/store/notifications.selectors';
import { Observable } from 'rxjs';
import { ApplicationFacadeService } from '@shared/service/application-facade.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-top-bar',
    templateUrl: './top-bar.component.html',
    styleUrls: ['./top-bar.component.scss'],
    standalone: false
})
export class TopBarComponent {
  private readonly store = inject(Store);

  public featureTitleKey$: Observable<string> = this.store.select(ApplicationSelectors.featureTitleKey);

  public hasUnreadNotifications$: Observable<boolean> = this.store.select(NotificationsSelectors.hasUnreadNotifications);

  @Input()
  public showSidebar: boolean = true;

  public collapsed: boolean = true;

  constructor(private applicationFacadeService: ApplicationFacadeService) {
    this.applicationFacadeService.mainLayoutClicked$.pipe(takeUntilDestroyed()).subscribe(() => this.collapsed = true);
  }

  public toggle(event): void {
    event.stopPropagation();
    this.collapsed = !this.collapsed;
  }
}
